import React, { useState } from 'react';
// import {
//   AlertCircle,
//   BookOpen,
//   ChevronRight,
//   CircleDot,
//   FileInput,
//   LayoutDashboard,
//   MapPin,
//   Star,
//   Truck,
//   Droplet
// } from 'lucide-react';
import { Container, Typography, List, ListItem, ListItemText } from '@mui/material';
// import manualjson from './Util/manual.json';
// import { useMediaQuery } from 'react-responsive';
// import { Menu, MenuItem, IconButton, Drawer } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';

// const iconMap = {
//   InfoIcon: BookOpen,
//   DashboardIcon: LayoutDashboard,
//   InputIcon: FileInput,
//   CalculateIcon: Truck,
//   VisibilityIcon: AlertCircle,
//   StarIcon: Star,
//   MapIcon: MapPin,
//   OilBarrelIcon: Droplet
// };

export default function UserManual() {
  // const [selectedSection, setSelectedSection] = useState('introduccion');
  // const [drawerOpen, setDrawerOpen] = useState(false);
  // const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  // const getIcon = (iconName) => {
  //   const IconComponent = iconMap[iconName];
  //   return IconComponent ? <IconComponent className="w-5 h-5" /> : <BookOpen className="w-5 h-5" />;
  // };

  // const renderFeaturesList = (items) => (
  //   <ul className="space-y-2">
  //     {items.map((item, idx) => (
  //       <li key={idx} className="flex items-center gap-2">
  //         <CircleDot className="w-3 h-3 text-primary" />
  //         <span className="text-sm text-gray-600">{item}</span>
  //       </li>
  //     ))}
  //   </ul>
  // );

  // const renderSteps = (steps) => (
  //   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  //     {steps?.map((step) => (
  //       <Card key={step.number} className="hover:shadow-lg transition-all">
  //         <CardHeader className="flex flex-row items-center gap-4">
  //           <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary text-white">
  //             {step.number}
  //           </div>
  //           <h3 className="text-lg font-semibold">{step.title}</h3>
  //         </CardHeader>
  //         <CardContent>
  //           <p className="text-gray-600 mb-4">{step.description}</p>
  //           {step.notes && (
  //             <div className="space-y-2">
  //               {step.notes.map((note, idx) => (
  //                 <div key={idx} className="flex items-start gap-2">
  //                   <ChevronRight className="w-4 h-4 text-primary mt-1" />
  //                   <span className="text-sm text-gray-500">{note}</span>
  //                 </div>
  //               ))}
  //             </div>
  //           )}
  //           {step.actions && (
  //             <div className="mt-4 space-y-2">
  //               {step.actions.map((action, idx) => (
  //                 <div key={idx} className="flex items-start gap-2">
  //                   <ChevronRight className="w-4 h-4 text-primary mt-1" />
  //                   <span className="text-sm text-gray-500">{action}</span>
  //                 </div>
  //               ))}
  //             </div>
  //           )}
  //         </CardContent>
  //       </Card>
  //     ))}
  //   </div>
  // );

  // const renderModalidades = (modalidades) => (
  //   <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
  //     {modalidades?.map((modalidad) => (
  //       <Card key={modalidad.name} className="hover:shadow-lg transition-all text-center">
  //         <CardContent className="pt-6">
  //           <div className="text-4xl mb-4">{modalidad.icon}</div>
  //           <h3 className="text-xl font-semibold text-primary mb-2">{modalidad.name}</h3>
  //           <p className="text-gray-600 text-sm">{modalidad.description}</p>
  //           {modalidad.details && (
  //             <p className="text-gray-500 text-sm mt-2 italic">{modalidad.details}</p>
  //           )}
  //         </CardContent>
  //       </Card>
  //     ))}
  //   </div>
  // );

  // const renderSectionContent = (section) => {
  //   if (section.features) {
  //     return Object.entries(section.features).map(([key, value]) => (
  //       <Card key={key} className="hover:shadow-lg transition-all">
  //         <CardContent className="pt-6">
  //           <h3 className="text-lg font-semibold mb-4">{value.title || key}</h3>
  //           {value.description && (
  //             <p className="text-gray-600 mb-4">{value.description}</p>
  //           )}
  //           {Array.isArray(value.items || value) &&
  //             renderFeaturesList(value.items || value)}
  //         </CardContent>
  //       </Card>
  //     ));
  //   }
  //   return null;
  // };

  // const renderLayout = (layout) => (
  //   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  //     {Object.entries(layout).map(([key, panel]) => (
  //       <Card key={key} className="hover:shadow-lg transition-all">
  //         <CardHeader>
  //           <h3 className="text-lg font-semibold">{panel.title}</h3>
  //         </CardHeader>
  //         <CardContent>
  //           <p className="text-gray-600 mb-4">{panel.description}</p>
  //           {panel.features && renderFeaturesList(panel.features)}
  //         </CardContent>
  //       </Card>
  //     ))}
  //   </div>
  // );

  // const renderContent = (sectionKey) => {
  //   const section = manualjson.sections[sectionKey];
  //   if (!section) return null;

  //   return (
  //     <div className="space-y-8">
  //       {/* Description Card */}
  //       {(section.description || section.content?.mainDescription) && (
  //         <Card className="bg-primary/5">
  //           <CardContent className="pt-6">
  //             <p className="text-gray-600">
  //               {typeof section.description === 'string'
  //                 ? section.description
  //                 : section.description?.general || section.content?.mainDescription}
  //             </p>
  //             {(section.description?.capabilities || section.content?.keyFeatures) && (
  //               <div className="mt-4">
  //                 {renderFeaturesList(
  //                   section.description?.capabilities ||
  //                   section.content?.keyFeatures
  //                 )}
  //               </div>
  //             )}
  //           </CardContent>
  //         </Card>
  //       )}

  //       {/* Layout Section */}
  //       {/* {section.layout && renderLayout(section.layout)} */}

  //       {/* Steps Section */}
  //       {/* {(section.steps || section.instructions?.steps) && 
  //         renderSteps(section.steps || section.instructions.steps)} */}

  //       {/* Modalidades Section */}
  //       {/* {section.modalidades && renderModalidades(section.modalidades)} */}

  //       {/* Features Section */}
  //       {/* {renderSectionContent(section)} */}

  //       {/* Sections with nested content */}
  //       {/* {section.sections && (
  //         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  //           {Object.entries(section.sections).map(([key, subsection]) => (
  //             <Card key={key} className="hover:shadow-lg transition-all">
  //               <CardHeader>
  //                 <h3 className="text-lg font-semibold">{subsection.title}</h3>
  //               </CardHeader>
  //               <CardContent>
  //                 {subsection.elements && renderFeaturesList(subsection.elements)}
  //               </CardContent>
  //             </Card>
  //           ))}
  //         </div>
  //       )} */}

  //       {/* Specifications Section */}
  //       {/* {section.specifications && (
  //         <Card className="hover:shadow-lg transition-all">
  //           <CardContent className="pt-6">
  //             <h3 className="text-lg font-semibold mb-4">Especificaciones</h3>
  //             {Object.entries(section.specifications).map(([key, value]) => (
  //               <div key={key} className="mb-4">
  //                 <h4 className="font-medium mb-2">{key}</h4>
  //                 {key === 'argumentos' ? (
  //                   <div>
  //                     <p>Unidad: {value.unit}</p>
  //                     <p>Rango: {value.range.min} - {value.range.max} {value.unit}</p>
  //                     <p>Decimales: {value.range.decimals}</p>
  //                   </div>
  //                 ) : key === 'tanque' ? (
  //                   <div>
  //                     <p>Unidad: {value.unit}</p>
  //                     <p>Opciones: {value.options.join(', ')}</p>
  //                   </div>
  //                 ) : (
  //                   <pre className="text-sm text-gray-600">
  //                     {JSON.stringify(value, null, 2)}
  //                   </pre>
  //                 )}
  //               </div>
  //             ))}
  //           </CardContent>
  //         </Card>
  //       )} */}
  //     </div>
  //   );
  // };

  // const renderSidebar = () => (
  //   <nav className="space-y-1">
  //     {Object.entries(manualjson.sections).map(([key, section]) => (
  //       <button
  //         key={key}
  //         onClick={() => {
  //           setSelectedSection(key);
  //           setDrawerOpen(false);
  //         }}
  //         className={`w-full flex items-center gap-3 px-4 py-2 rounded-lg text-left
  //           ${selectedSection === key
  //             ? 'bg-primary/10 text-primary font-medium'
  //             : 'text-gray-600 hover:bg-gray-50'
  //           }`}
  //       >
  //         {getIcon(section.icon)}
  //         <span>{section.title}</span>
  //       </button>
  //     ))}
  //   </nav>
  // );

  return (
    <div className='all-center flex-col'>
      <Container className="p-4">
        <Typography variant="h5" className="text-center font-bold mb-4  text-blue-500">
          ASISTENTE DE EL TRANSPORTE DE CARGA
        </Typography>
        <Typography className="mb-2">
          Para información y asistencias llame a los siguientes números:
        </Typography>
        <List>
  <ListItem style={{ margin: 0, padding: 0 }}>
    <ListItemText primary="(503) 2219-6597" />
  </ListItem>
  <ListItem style={{ margin: 0, padding: 0 }}>
    <ListItemText primary="(503) 6436-5877" />
  </ListItem>
</List>
        <Typography className="mb-2 text-blue-500 hover:underline">
      <a href="mailto:GlobalAdvacedData@gmail.com">GlobalAdvacedData@gmail.com</a>
    </Typography>  <Typography className="mb-4">
          El Asistente de el Transporte de Carga es una Aplicación Web que ayuda a los
          Transportistas de Carga de Centroamérica en la obtención de toda la Información que
          necesitan para establecer fletes sean éstos locales o internacionales, así como para
          ejecutar tareas de búsqueda de información para el trabajo de el Transporte de Carga.
        </Typography>
        <br></br>
        <Typography className="mt-8 mb-2">
          Sus 6 funciones son las siguientes:
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary={<strong>• Obtener Información de un Flete</strong>} />
          </ListItem>
          <ListItem>
            <ListItemText primary={<strong>• Obtener Distancia de una Ruta</strong>} />
          </ListItem>
          <ListItem>
            <ListItemText primary={<strong>• Calcular Consumo de combustible</strong>} />
          </ListItem>
          <ListItem>
            <ListItemText primary={<strong>• Calcular Galones en Tanques</strong>} />
          </ListItem>
          <ListItem>
            <ListItemText primary={<strong>• Elaborar Documentos de Transito</strong>} />
          </ListItem>
          <ListItem>
            <ListItemText primary={<strong>• Indicaciones de la APP</strong>} />
          </ListItem>
        </List>
        <Typography className="mt-4">
          En la primera función, <strong>Obtener Información de un Flete</strong> el Asistente brinda todos los datos
          necesarios que se generan al hacer un flete entre dos ciudades, sin importar las diferentes
          modalidades que éste tenga que pueden ser cargado-cargado, cargado-vacio o vacio-cargado,
          aun tomando en cuenta si se traslada a una ciudad distinta para la carga de retorno o para
          cargar hacia otra ciudad. Brinda el consumo de combustible de la ruta, el gasto que genera ese
          combustible, los gastos de operación del tránsito como el pago del piloto y los viáticos, detalla
          el costo de mantenimiento que un flete debe reservar para el mantenimiento cuando se presente,
          el costo del aporte a la administración, la utilidad que se obtiene del flete y la tarifa idónea a cobrar.
        </Typography>
        <br></br>
        <Typography className="mt-4">
          Presionando el icono de la primera función, solo debe ingresar 4 datos y ejecutar un par de
          indicaciones que le solicita y el Asistente hará todo el trabajo de cálculos. Solo debe ingresar
          la Ciudad de donde parte el flete, la Ciudad destino a donde se dirige sin importar que la primera
          ruta sea vacío, el peso de la carga a mover en kilogramos y el precio del combustible actual en su país.
        </Typography>
        <br></br>
        <Typography className="mt-4">
          El Asistente de El Transporte de Carga le muestra la ruta que debe seguir el piloto, todo está
          predeterminado entre las ciudades de principal carga para el Transporte pesado que va desde 8, 10,
          12 hasta 24 toneladas. Le dice la mejor alternativa de ruta en la distancia dada siguiendo las rutas
          fiscales para el Transporte de carga y las fronteras más recomendadas.
        </Typography>
        <br></br>
        <Typography className="mt-4">
          La Aplicación además le asiste para estructurar nuevas rutas, las rutas entre las principales ciudades
          en las que se mueve carga vía terrestre en los países de la región ya están establecidas y las fronteras
          que resultan la mejor opción. Sin embargo, puede darse el caso que deba cambiarse la ruta debido a que
          hay contingencias que no permiten el paso por la ruta que se ha establecido, debido a paros, cierres de
          fronteras, por daños en las estructuras, por afectaciones generadas por el clima o simplemente porque así
          lo solicita el cliente. En ese caso, puede generar los datos entre la ciudad de un país con la frontera
          que decida utilizar como segunda opción y luego solicitar la información entre esa frontera y la ciudad
          del siguiente país y simplemente sumar ambos resultados.
        </Typography>
        <br></br>
        <Typography className="mt-4">
          Existen ciudades entre países que no se acostumbra carga entre ellas por lo cual no están predeterminadas.
          Sin embargo, su asistente le ayuda a estructurar una ruta conectando la primer ciudad con la frontera que
          le resulta como mejor alternativa y luego esa frontera con la ciudad destino, incluso se puede hacer usando
          de frontera a frontera si hay países de por medio.
        </Typography>
        <br></br>
        <Typography className="mt-4">
          Cuenta con las funciones <strong>Calcular Distancia de una Ruta y Calcular Consumo de Combustible</strong> funciones que
          son para obtener datos individuales de kilometraje de una ruta y consumos. En ellas solo ingrese los datos
          que le solicita su asistente.
        </Typography>
        <br></br>
        <Typography className="mt-4">
          Los datos a ingresar son la Ciudad de donde parte y la Ciudad a donde se dirige y brindar las indicaciones
          que se le solicitan para realizar los cálculos precisos.
        </Typography> 
        <br></br>
        <Typography className="mt-4">
          El Asistente de el Transporte de Carga tiene además la función de ayuda <strong>Calcular Galones en Tanques</strong> la cual
          le asiste a saber la cantidad de galones que tiene dentro de un tanque. La costumbre es medir el nivel de un
          tanque en pulgadas para saber el nivel que tiene. Utilizando su función, usted solo debe ingresar las pulgadas
          y medias pulgadas, indicar el tipo de tanque que anda su equipo y el Asistente le dirá cuantos galones tiene
          disponibles.
        </Typography>
        <br></br>
        <Typography className="mt-4">
          Una de las funciones más importantes es la de <strong>Elaborar Documentos de Transito.</strong> Al ingresar en esta función
          encontrará una plantilla para ingresar la información que contiene el Formulario Aduanero y la factura. Al
          terminar de ingresar toda la información de la misma manera como ya lo hace en su equipo, automáticamente se
          generan la Carta de Porte, el Manifiesto de Carga y una Ficha guía para la elaborar la Guía de Transito o DUCA.
          El archivo generado lo puede visualizar y luego enviarlo vía correo o a impresión si trabaja desde su computadora.
          Incluso puede enviar en tránsito a sus pilotos y transmitir los documentos por correo a su agencia en frontera y
          al llegar ya se los tienen listos y el trámite avanzado.
        </Typography>
        <br></br>
        <Typography className="mt-4">
          La aplicación le permite descargarla en 3 dispositivos diferentes, en su teléfono móvil, su tablet o en su
          computadora. Al suscribirse, su usuario puede hacer uso de ella en los 3 tipos de dispositivo. Sin embargo, el
          uso en más de 3 dispositivos con el mismo usuario restringirá la aplicación.
        </Typography>
        <br></br>
        <Typography className="mt-4 font-bold">
          No entregue su usuario a nadie.
        </Typography>
      </Container>
      {/* Top bar with Hamburger Menu */}
      {/* {isMobile && (
        <div className="flex items-center p-4 bg-white shadow-md">
          <IconButton onClick={() => setDrawerOpen(true)}>
            <MenuIcon />
          </IconButton>
          <h1 className="text-xl font-semibold text-primary ml-4">Manual de Usuario</h1>
        </div>
      )} */}

      {/* Sidebar or Drawer */}
      {/* <div className="flex flex-1">
        {isMobile ? (
          <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
            <div className="w-64 p-4">
              <h1 className="text-xl font-semibold text-primary mb-6">Manual de Usuario</h1>
              {renderSidebar()}
            </div>
          </Drawer>
        ) : (
          <div className="w-64 border-r min-h-screen p-4 bg-white">
            <h1 className="text-xl font-semibold text-primary mb-6">Manual de Usuario</h1>
            {renderSidebar()}
          </div>
        )}
    
        {/* Main content */}
      {/*}
        <div className="flex-1 p-8">
          <h2 className="text-2xl font-semibold mb-6">
            {manualjson.sections[selectedSection]?.title}
          </h2>
          {renderContent(selectedSection)}
        </div>
      </div> */}

    </div>
  );
}